<template>
  <div class="modal fade" id="vehicleBpmModal" tabindex="-1" aria-labelledby="vehicleBpmModalLabel" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="vehicleBpmModalLabel">Авто</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <vehicle-bpm-search
            v-if="search.step === 0"
            :is-clear="clear"
            :car-added-list="carAddedList"
            :product-type="productType"
            :search-data="search.data"
            :process-id="search.processId"
            :module="module"
            :mode="mode"
            @search-vehicle="searchVehicle"
          />
          <vehicle-bpm-data
            v-if="search.step >= 1"
            :search-data="search.data"
            :product-type="productType"
            :is-clear="clear"
            :vehicle-data="info[0] ? [clone(info[0])] : null"
            :is-edit="isEdit"
            :module="module"
            :mode="mode"
            @cancel="cancel"
            @set-vehicle="setVehicle"
          />
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            data-bs-dismiss="modal"
            @click="clearForm"
          >Закрыть</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleBpmSearch from '@/components/Form/Bpm/Vehicle/VehicleBpmSearch.vue'
import VehicleBpmData from '@/components/Form/Bpm/Vehicle/VehicleBpmData.vue'
import LoaderFull from '@/components/Main/LoaderFull.vue'

export default {
  name: 'VehicleBpmModal',
  components: {
    LoaderFull,
    VehicleBpmSearch,
    VehicleBpmData,
  },
  props: {
    carAddedList: {
      type: Array,
      default: () => [],
    },
    productType: {
      type: Number,
      default: 0,
    },
    vehicle: {
      type: Object,
      default: null,
    },
    module: {
      type: Function,
      required: true,
    },
    mode: {
      type: [Object, Function],
      required: true,
    },
  },
  data () {
    return {
      search: {
        data: null,
        step: 0,
        processId: null,
      },
      isEdit: false,
      clear: false,
      loader: false,
      info: { 0: {} },
    }
  },
  watch: {
    vehicle: {
      deep: true,
      immediate: true,
      handler (val) {
        this.applyModalState(val)
      },
    },
  },
  methods: {
    applyModalState (val) {
      if (!val) {
        this.clearForm()
        return
      }

      if (!val.data) {
        if (Object.prototype.hasOwnProperty.call(val, 'step') && val.step === 0) {
          this.isEdit = false
          this.info = { 0: {} }
          this.search.step = 0
          this.search.data = null
          this.search.processId = val.processId ?? null
          return
        }
        this.clearForm()
        return
      }

      if (Object.prototype.hasOwnProperty.call(val, 'step') && val.step === 0) {
        this.isEdit = false
        this.info = { 0: {} }
        this.search.step = val.step
        this.search.data = val.data
      } else {
        this.search.data = null
        this.info = { 0: val.data }
        this.isEdit = true
        this.search.step = 3
        this.search.edited = { key: val.key }
      }

      this.search.processId = val.processId ?? null
    },
    clone (val) {
      return structuredClone(val)
    },
    cancel () {
      this.search.step = 0
    },
    modalHidden () {
      const modal = window.bootstrap?.Modal.getInstance(document.getElementById('vehicleBpmModal'))
      modal?.hide()
    },
    clearForm () {
      this.search.data = null
      this.search.step = 0
      this.search.processId = null
      this.isEdit = false
      this.clear = true
      this.info = { 0: {} }
      if (this.clear) {
        this.$emit('clear-vehicle', this.clear)
        setTimeout(() => { this.clear = false }, 50)
      }
    },
    searchVehicle (val) {
      this.modalHidden()
      this.$emit('search-vehicle', val)
    },
    setVehicle (val) {
      this.modalHidden()
      this.$emit('set-vehicle', val)
    },
  },
}
</script>

<style scoped>

</style>
